module.exports = __webpack_public_path__ + "static/img/industriesbg1.399adae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg1.jpg
// module id = ZoMC
// module chunks = 1